import { render, staticRenderFns } from "./SaleInvoicesProfileCard.vue?vue&type=template&id=47ba51a2&scoped=true&"
import script from "./SaleInvoicesProfileCard.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba51a2",
  null
  
)

export default component.exports